// extracted by mini-css-extract-plugin
module.exports = {"styledTitle":"Title_styledTitle__2yS3W"};